import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6be2f0c")

_pushScopeId("data-v-b6be2f0c")
const _hoisted_1 = {
  style: {"width":"100%"},
  class: "el-submenu",
  role: "menuitem",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_2 = {
  style: {"height":"100%","width":"100%","padding-left":"20px"},
  class: "el-submenu__title el-submenu__style"
}
const _hoisted_3 = { class: "current_img" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "el-icon-caret-right" }, null, -1)
const _hoisted_5 = { class: "side_menu_list" }
const _hoisted_6 = { class: "project_icon" }
const _hoisted_7 = { style: {"font-size":"12px"} }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { style: {"font-size":"12px"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_aside, {
            class: "fixed",
            width: "220px",
            style: {"background-color":"#545c64","z-index":"9"}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_menu, {
                router: "",
                "default-active": _ctx.$route.path,
                "default-openeds": _ctx.openeds,
                class: "el-menu-vertical-demo side_menu head_fix",
                collapse: _ctx.isCollapse,
                "background-color": "#545c64",
                "text-color": "#fff",
                "active-text-color": "#ffd04b",
                style: {"background-color":"#545c64","border":"0"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_menu_item, { class: "el-menu-style" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_popover, {
                        placement: "right",
                        width: 229,
                        trigger: "hover",
                        class: "popover"
                      }, {
                        reference: _withId(() => [
                          _createVNode("li", _hoisted_1, [
                            _createVNode("div", _hoisted_2, [
                              _createVNode("p", null, [
                                _createVNode("span", _hoisted_3, [
                                  _createVNode("img", {
                                    src: _ctx.currentProjectIcon,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("span", null, _toDisplayString(_ctx.getMyLastProjectName), 1)
                              ]),
                              _hoisted_4
                            ])
                          ])
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.search,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
                            size: "mini",
                            placeholder: "输入关键字"
                          }, null, 8, ["modelValue"]),
                          _createVNode("ul", _hoisted_5, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjects(_ctx.search), (item) => {
                              return (_openBlock(), _createBlock("li", {
                                key: item,
                                onClick: ($event: any) => (_ctx.changeProject(item.project.id))
                              }, [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode("img", {
                                    src: item.project.icon,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("span", null, _toDisplayString(item.project.project_name), 1)
                              ], 8, ["onClick"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.asideMenu, (mitem, mindex) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item_group, {
                      key: mindex,
                      index: mitem.index
                    }, {
                      title: _withId(() => [
                        _createTextVNode(_toDisplayString(mitem.title), 1)
                      ]),
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(mitem.sub, (sitem) => {
                          return (_openBlock(), _createBlock("div", {
                            key: sitem.title,
                            index: sitem.path
                          }, [
                            (sitem.children)
                              ? (_openBlock(), _createBlock(_component_el_submenu, {
                                  key: 0,
                                  style: sitem.style,
                                  index: sitem.path
                                }, {
                                  title: _withId(() => [
                                    _createVNode("div", null, [
                                      _createVNode("i", {
                                        class: sitem.icon,
                                        style: {"font-size":"14px"}
                                      }, null, 2),
                                      _createTextVNode(_toDisplayString(sitem.title), 1)
                                    ])
                                  ]),
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(sitem.children, (childrens) => {
                                      return _withDirectives((_openBlock(), _createBlock("div", {
                                        key: childrens.path
                                      }, [
                                        (childrens.children)
                                          ? (_openBlock(), _createBlock(_component_el_submenu, {
                                              key: 0,
                                              index: childrens.path,
                                              style: {"font-size":"12px"}
                                            }, {
                                              title: _withId(() => [
                                                _createVNode("div", _hoisted_7, [
                                                  _hoisted_8,
                                                  _createTextVNode(_toDisplayString(childrens.title), 1)
                                                ])
                                              ]),
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(childrens.children, (thirdLevelChild) => {
                                                  return (_openBlock(), _createBlock("div", {
                                                    key: thirdLevelChild.path
                                                  }, [
                                                    (thirdLevelChild.children)
                                                      ? (_openBlock(), _createBlock(_component_el_submenu, {
                                                          key: 0,
                                                          index: thirdLevelChild.path,
                                                          style: {"padding-left":"67px","font-size":"10px"}
                                                        }, {
                                                          title: _withId(() => [
                                                            _createVNode("div", null, _toDisplayString(thirdLevelChild.title), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(thirdLevelChild.children, (fourthLevelChild) => {
                                                              return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                                key: fourthLevelChild.path,
                                                                index: fourthLevelChild.path,
                                                                onClick: ($event: any) => (
                            _ctx.handleMenuItemClick(fourthLevelChild.path, $event)
                          )
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createTextVNode(_toDisplayString(fourthLevelChild.title), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["index", "onClick"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index"]))
                                                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                                                          key: 1,
                                                          index: thirdLevelChild.path,
                                                          onClick: ($event: any) => (
                          _ctx.handleMenuItemClick(thirdLevelChild.path, $event)
                        )
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(thirdLevelChild.title), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["index", "onClick"]))
                                                  ]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                          : (_openBlock(), _createBlock(_component_el_menu_item, {
                                              key: 1,
                                              style: {"font-size":"12px"},
                                              index: childrens.path,
                                              onClick: ($event: any) => (_ctx.handleMenuItemClick(childrens.path, $event))
                                            }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(childrens.title), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["index", "onClick"]))
                                      ], 512)), [
                                        [_vShow, childrens.show]
                                      ])
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["style", "index"]))
                              : (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: 1,
                                  index: sitem.path,
                                  disabled: 
                  sitem.path === '/image-recognition-script' ||
                  sitem.path === '/report-settings' ||
                  sitem.path === '/notification-settings'
                ,
                                  style: sitem.style,
                                  onClick: ($event: any) => (_ctx.handleMenuItemClick(sitem.path, $event))
                                }, {
                                  default: _withId(() => [
                                    _createVNode("i", {
                                      class: sitem.icon,
                                      style: {"font-size":"14px"}
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(sitem.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index", "disabled", "style", "onClick"]))
                          ], 8, ["index"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active", "default-openeds", "collapse"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_view, { searchVal: _ctx.searchVal }, null, 8, ["searchVal"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})